import { useEffect } from 'react';
import { initializeMetaPixel } from '../lib/metaPixel';
export function MetaPixel() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return null;
}